export const SET_LOADING = '@orders/SET_LOADING';
export const SAVE_DATA = '@orders/SAVE_DATA';
export const SET_FILTER = '@orders/SET_FILTER';
export const SET_ACTIVE_PAGE = '@orders/SET_ACTIVE_PAGE';
export const VM_LOADING = '@orders/VM_LOADING';
export const BTN_LOADING = '@orders/BTN_LOADING';
export const SET_VM_OPTIONS = '@orders/SET_VM_OPTIONS';
export const SET_VM_SELECTED_OPTION = '@orders/SET_VM_SELECTED_OPTION';



// WEBPACK FOOTER //
// ./src/Modules/Orders/constants.js